<button mat-icon-button [matMenuTriggerFor]="menu" (click)="stopPropagation($event)">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button *ngIf="isPending()" mat-menu-item (click)="btnApproveClicked()">
    <span>{{ "RESOURCE_LIST.ADMIN.APPROVE" | translate }}</span>
  </button>
  <div *ngIf="isNotCompleted()">
    <button *ngIf="isPriorityHigh(); else priorityNormal" mat-menu-item (click)="btnSetNormalPrioClicked()">
      <span>{{ "RESOURCE_LIST.ADMIN.SET_NORMAL" | translate }}</span>
    </button>
    <ng-template #priorityNormal>
      <button mat-menu-item (click)="btnSetHighPrioClicked()">
        <span>{{ "RESOURCE_LIST.ADMIN.SET_HIGH" | translate }}</span>
      </button>
    </ng-template>
  </div>
  <button *ngIf="isPaid(); else nonpaid" mat-menu-item (click)="btnSetNonPaidClicked()">
    <span>{{ "RESOURCE_LIST.ADMIN.SET_AS_NONPAID" | translate }}</span>
  </button>
  <ng-template #nonpaid>
    <button mat-menu-item (click)="btnSetPaidClicked()">
      <span>{{ "RESOURCE_LIST.ADMIN.SET_AS_PAID" | translate }}</span>
    </button>
  </ng-template>
  <button mat-menu-item (click)="btnDeleteClicked()">
    <span>{{ "RESOURCE_LIST.ADMIN.DELETE" | translate }}</span>
  </button>
  <button mat-menu-item (click)="btnDetailsClicked()">
    <span>{{ "RESOURCE_LIST.ADMIN.DETAILS" | translate }}</span>
  </button>
  <button *ngIf="isIrrelevant()" mat-menu-item (click)="btnSetUnassignedClicked()">
    <span>{{ "RESOURCE_LIST.ADMIN.SET_UNASSIGNED" | translate }}</span>
  </button>

</mat-menu>
